import Seo from "../components/Seo";
import CtaBand from "../components/CtaBand";
import PageHero from "../components/PageHero";

const ChiSono = () => (
  <>
    <Seo
      title="Chi sono | Avv. Manfredi Bruno, avvocato del lavoro a Palermo"
      description="L'Avv. Manfredi Bruno, avvocato del lavoro e della previdenza a Palermo: il percorso professionale, l'approccio al cliente e il modo di lavorare dello studio."
      path="/chi-sono"
    />
    <PageHero
      kicker="Chi sono"
      title="Avv. Manfredi Bruno"
      intro="Avvocato del lavoro e della previdenza a Palermo"
      breadcrumb="Chi sono"
    />

    <section className="bg-white py-14 sm:py-20">
      <div className="container-site grid gap-12 lg:grid-cols-[380px_1fr]">
        <div className="relative mx-auto w-full max-w-sm lg:max-w-none">
          <div className="absolute -left-3 -top-3 h-full w-full rounded-2xl border border-gold/40" aria-hidden="true" />
          <img
            src="/images/avv-portrait.webp"
            alt="Ritratto dell'Avv. Manfredi Bruno nel suo studio legale a Palermo"
            data-testid="about-portrait"
            className="relative w-full rounded-2xl object-cover shadow-xl"
            loading="lazy"
          />
        </div>
        <div className="legal-prose max-w-3xl">
          <h2 className="mt-0">Un avvocato, prima di tutto una persona che ascolta</h2>
          <p>
            Sono Manfredi Bruno, avvocato, e il mio studio si trova a Palermo, in Via
            Salvatore Meccio 22. Ho scelto di dedicare la mia attività professionale al
            diritto del lavoro e al diritto previdenziale perché sono materie che
            riguardano la vita concreta delle persone: il posto di lavoro, la retribuzione,
            la pensione, la salute.
          </p>
          <p>
            Chi si rivolge a un avvocato del lavoro o previdenzialista si trova spesso in
            un momento di difficoltà: un licenziamento, uno stipendio che non arriva, una
            domanda respinta dall'INPS. Il mio compito è prima di tutto ascoltare e
            comprendere la situazione, e solo dopo individuare gli strumenti giuridici più
            adatti. Non esistono due casi uguali: ogni situazione merita una valutazione
            propria, fatta sui documenti e sui fatti.
          </p>
          <h2>Come lavoro</h2>
          <p>
            Credo in un rapporto diretto con il cliente, costruito sulla chiarezza. Prima
            di avviare qualsiasi iniziativa, ti spiego quali sono le possibilità concrete,
            quali i rischi, quali i tempi prevedibili e quali i costi. Quando una
            controversia può risolversi in via stragiudiziale, con una trattativa o una
            conciliazione, te lo dico: il giudizio è uno strumento, non un obiettivo.
          </p>
          <p>
            Lavoro principalmente con lavoratori, pensionati e privati cittadini di Palermo
            e provincia. Ricevo su appuntamento, perché ogni colloquio richiede il tempo
            necessario per essere davvero utile.
          </p>
          <h2>Il primo incontro</h2>
          <p>
            Il primo appuntamento serve a comprendere la tua situazione: porta con te i
            documenti che hai a disposizione — lettere, buste paga, provvedimenti INPS,
            verbali — e li esamineremo insieme. Al termine avrai un quadro chiaro della
            tua posizione e delle strade percorribili, e potrai decidere con serenità come
            procedere.
          </p>
        </div>
      </div>
    </section>

    <section className="bg-gold-soft py-14 sm:py-20">
      <div className="container-site">
        <h2 className="font-serif text-2xl sm:text-3xl font-semibold text-navy">Lo studio</h2>
        <div className="mt-8 grid gap-6 sm:grid-cols-3">
          <img
            src="/images/avv-standing.webp"
            alt="L'Avv. Manfredi Bruno durante un colloquio con un cliente nel suo studio di Palermo"
            data-testid="about-photo-standing"
            className="h-72 w-full rounded-2xl object-cover shadow-md"
            loading="lazy"
          />
          <img
            src="/images/avv-reading.webp"
            alt="L'Avv. Manfredi Bruno esamina la documentazione di una pratica di lavoro"
            data-testid="about-photo-reading"
            className="h-72 w-full rounded-2xl object-cover shadow-md"
            loading="lazy"
          />
          <img
            src="/images/studio-ingresso.webp"
            alt="L'ingresso dello studio legale in Via Salvatore Meccio 22 a Palermo"
            data-testid="about-photo-studio"
            className="h-72 w-full rounded-2xl object-cover shadow-md"
            loading="lazy"
          />
        </div>
      </div>
    </section>

    <CtaBand
      title="Vuoi parlarmi della tua situazione?"
      text="Prenota un appuntamento presso lo studio a Palermo: ascolterò la tua situazione e ti aiuterò a comprendere le possibili forme di tutela."
    />
  </>
);

export default ChiSono;
